import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  () => ({
    root: {
      "& p": {
        marginBlockStart: 0,
        marginBlockEnd: 0
      }
    }
  }),
  {
    name: "TextEditor"
  }
);
